// import React from "react";
// import { AppGeneralTextContext } from "./app_context/app_context";

// const ProfileHistorian = () => {
//   const appGeneralTextData = React.useContext(AppGeneralTextContext);
//   const { general_text_data }: any = appGeneralTextData;
//   return (
//     <div className="services-container">
//       <div className="intro-header">
//         <h1>Profile Historian</h1>
//       </div>
//       {/* <div className="intro-banner-container">
//         <BannerImage />
//       </div> */}
//       <div className="intro-content"> {general_text_data.coming_soon}</div>
//     </div>
//   );
// };

// export default ProfileHistorian;

import React, { useEffect } from "react";
import { AppGeneralTextContext } from "./app_context/app_context";
import { useLocation } from "react-router-dom";
import { useHMI } from "./app_context/HMIContext";

const ProfileHistorian = (props: any) => {
  const appGeneralTextData = React.useContext(AppGeneralTextContext);
  const { general_text_data }: any = appGeneralTextData;
  const location = useLocation();
  const { setHMIData } = useHMI();
  const { url: rawUrl, name } = location.state || { url: "" };
  const url =
    rawUrl.startsWith("https://") || rawUrl.startsWith("http://")
      ? rawUrl
      : `https://${rawUrl}`;
  useEffect(() => {
    setHMIData((prevData: any) => ({
      ...prevData,
      header_props: {
        ...prevData.header_props,
        breacrumbName: name,
      },
    }));
    //add cleanup
    return () => {
      setHMIData((prevData: any) => ({
        ...prevData,
        header_props: {
          ...prevData.header_props,
          breacrumbName: null,
        },
      }));
    };
  }, [name]);

  return (
    <div className="iframe-wrapper">
      <iframe
        title="Profile Historian"
        src={url}
        frameBorder="0"
        allowFullScreen
        style={{ width: "100%", height: "88vh" }}
      ></iframe>
    </div>
  );
};

export default ProfileHistorian;
